import React from 'react';

import { useTranslation } from 'react-i18next';

import { useFollowersPanel, useMembersPanel } from '@pkg/hooks';

import GroupCount from '../parts/GroupCount';
import GroupFollowerGains from '../parts/GroupFollowerGains';

import { GroupHeaderFollowerInfoSection } from './styles';

interface Props {
    membersCount?: number;
    followerCount?: number;
    followerCountWeek?: number;
    membershipClickable?: boolean;
    podId: string;
}

export const GroupHeaderFollowerInfo = ({
    followerCount,
    membersCount,
    membershipClickable = true,
    followerCountWeek = 0,
    podId,
    ...others
}: Props) => {
    const { t } = useTranslation(['groups']);
    const { openPanel: openMembersPanel } = useMembersPanel();
    const { openPanel: openFollowersPanel } = useFollowersPanel();

    const handleOpenMembersPanel = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        e.preventDefault();
        openMembersPanel(podId);
    };
    const handleOpenFollowersPanel = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        e.preventDefault();
        openFollowersPanel(podId);
    };

    return (
        <GroupHeaderFollowerInfoSection {...others}>
            {!!membersCount && (
                <GroupCount
                    onClick={membershipClickable ? handleOpenMembersPanel : undefined}
                    label={t('groups_members')}
                    count={membersCount}
                />
            )}
            {!!followerCount && (
                <GroupCount
                    onClick={membershipClickable ? handleOpenFollowersPanel : undefined}
                    label={t('groups_followers')}
                    count={followerCount}
                />
            )}
            {followerCountWeek > 0 && !!followerCount && <GroupFollowerGains gainNumber={followerCountWeek} />}
        </GroupHeaderFollowerInfoSection>
    );
};
